import BlogDetail from "../../../commonComponents/blogDetail";

const BlogSliderLayoutContainer = () => {
  return <BlogDetail type="slider" />;
};

export default BlogSliderLayoutContainer;
